angular.module('dnecom')
    .controller('ServiceProfileController', ServiceProfileController);

ServiceProfileController.$inject = ['$scope', '$http', '$timeout', 'notifications', 'wizardModal'];

function ServiceProfileController($scope, $http, $timeout, notifications, wizardModal) {
    $scope.loading = false;
    $scope.error = false;
    $scope.serviceProfiles = [];

    $scope.tableInstance = {};
    $scope.dtInstanceCallback = function(dtInstance)
    {
        $scope.tableInstance = dtInstance;
    };

    $scope.searchTable = function(search) {
        $scope.tableInstance.DataTable.search(search);
        $scope.tableInstance.DataTable.draw();
    };

    $scope.dtServiceProfilesColumnDefs = [{
        targets: 2,
        width: '150px',
        orderable: false
    }];

    $scope.init = function() {
        $scope.getServiceProfiles();
    };

    $scope.addServiceProfile = function() {
        $scope.editServiceProfile();
    };

    $scope.editServiceProfile = function(serviceProfile, index) {
        var add = false;
        if (!serviceProfile) {
            serviceProfile = {instructionText: '', name: ''};
            add = true;
        }

        $scope.currentServiceProfile = angular.copy(serviceProfile);
        var serviceProfileModal = wizardModal.open({
            templateUrl: 'serviceProfileModal.html',
            size: 'lg',
            controller: 'ServiceProfileModalController',
            resolve: {
                serviceProfile: function() {
                    return $scope.currentServiceProfile;
                }
            }
        });

        serviceProfileModal.result.then(function(response) {
            if (add) {
                $scope.serviceProfiles.push(response.serviceProfile);
            } else {
                $scope.updateServiceProfile(response.serviceProfile);
            }
        }, function() {
            if (index && !angular.equals($scope.currentServiceProfile, $scope.serviceProfiles[index])) {
                $scope.serviceProfiles[index] = $scope.currentServiceProfile;
            }
        });
    };

    $scope.updateServiceProfile = function(serviceProfile) {
        for (var i in $scope.serviceProfiles) {
            if ($scope.serviceProfiles[i].id == serviceProfile.id) {
                $scope.serviceProfiles[i] = serviceProfile;
                return;
            }
        }
    };

    $scope.getServiceProfiles = function() {
        $scope.loading = true;
        $http.get(Routing.generate('instruction_profiles_get')).success(function(data) {
            if (data.hasOwnProperty('serviceProfiles')) {
                $scope.serviceProfiles = data.serviceProfiles;
            } else {
                notifications.danger('Request error.');
            }
        }).finally(function() {
            $timeout(function() {
                $scope.loading = false;
            });
        });
    };

    $scope.deleteServiceProfile = function(serviceProfile) {
        $http.delete(Routing.generate('instruction_profiles_delete', {
            id: serviceProfile.id
        }))
            .then(function(response) {
                if (response.data.success) {
                    $scope.getServiceProfiles();
                    notifications.success('Service profile has been deleted.');
                } else {
                    notifications.danger(response.data.message);
                }
            }, function(response) {
                notifications.danger('Request error.');
            });
    };
};
